import React from 'react'
import cn from 'classnames'

import { Back } from '../Back'

import styles from './styles.module.scss'

const AboutCC = () => (
	<article className={styles.article}>
		<Back />
		<h1 className={styles.heading}>О компании Credit.Club</h1>
		<p className={styles.contentHeading}>Содержание</p>
		<nav className={styles.nav}>
			<ul>
				<li className={styles.navItem}>
					<a className={styles.link} href='#what-is-it'>
						Что такое Credit.Club?
					</a>
				</li>
				<li className={styles.navItem}>
					<a className={styles.link} href='#documents'>
						Какие документы регулируют вашу деятельность?
					</a>
				</li>
			</ul>
		</nav>
		<h3 id='what-is-it' className={styles.title}>
			Что такое Credit.Club?
		</h3>
		<p className={styles.paragraph}>
			Credit.Club — платформа цифровых решений для кредитования. На базе наших технологий мы создаём
			удобные и доступные кредитные продукты. Нам важно, чтобы наши заёмщики могли быстро решать
			свои финансовые вопросы не выходя из дома.{' '}
		</p>
		<p className={styles.paragraph}>
			Команда Credit.Club работает в соответствии с российским законодательством, выполняя все
			требования регулирующих организаций. Компании из группы в зависимости от стоящих перед ними
			требований находятся под надзором Банка России, саморегулируемых организаций СРО «МиР» и НСКК
			«Содействие».
		</p>
		<h3 className={styles.title}>История</h3>
		<p className={cn(styles.paragraph, styles.paragraphBeforeList)}>
			В 2012 году мы зарегистрировали первую компанию из нашей группы: МКК «Магазин Кредитов»
			(6678014749). Тогда мы стали выдавать займы предпринимателям и частным лицам, а также
			увеличивать экспертизу в нескольких сферах:
		</p>
		<ul className={styles.list}>
			<li className={styles.item}>— доступного залогового кредитования и кредитных технологий,</li>
			<li className={styles.item}>— детальной экономической оценки недвижимости,</li>
			<li className={styles.item}>— юридической проверки заёмщика и объекта залога.</li>
		</ul>
		<p className={styles.paragraph}>
			В 2017 году приступили к разработке первых версий методики оценки недвижимости, конструктора
			договоров и приложения для операторов, чтобы автоматизировать часть процессов внутри компании.
		</p>
		<p className={styles.paragraph}>
			В 2018 году мы стали усиливать команду. Нам было важно находить одних из лучших специалистов в
			своих сферах, чтобы создавать не только удобные и эффективные продукты для клиентов, но и
			помогать команде постоянно расти, делиться своим опытом.
		</p>
		<p className={styles.paragraph}>
			К 2019 году мы трансформировались в финтех-компанию и поняли, что можем создать интересный
			платформенный сервис. В итоге в декабре этого же года запустили инвестиционную платформу,
			которая объединяет инвесторов и заёмщиков по всей России: одни могут помогать другим напрямую
			не выходя из дома.{' '}
		</p>
		<p className={styles.paragraph}>
			В 2020 году мы совершенствовали направление инвестирования в залоговые займы и продолжали
			развивать IT-систему, чтобы клиенты получали одни из лучших финансовых продуктов на рынке.
		</p>
		<p className={styles.paragraph}>
			Мы в очередной раз подтвердили свою надёжность, пройдя проверку Банком России, — компания из
			группы Credit.Club вступила в реестр операторов инвестиционных платформ
		</p>
		<p className={styles.paragraph}>
			Также одна из компаний стала участником проекта инновационного центра «Сколково».
		</p>
		<p className={styles.paragraph}>
			В этом же году мы собрали всю накопленную экспертизу, IT-разработки и создали платформу
			цифровых решений, которая делает рынок нецелевого залогового кредитования технологичнее и
			доступнее для всех сторон сделки. Это позволяет различным финансовым компаниям
			масштабироваться без открытия офисов, а клиентам — получать деньги по рыночной ставке и
			оформлять все нужные документы онлайн.
		</p>

		<h3 id='documents' className={styles.title}>
			Какие документы регулируют вашу деятельность?
		</h3>
		<p className={cn(styles.paragraph, styles.paragraphBeforeList)}>Их много. Вот основные: </p>
		<ol className={styles.orderedList}>
			<li className={styles.orderedItem}>Федеральный закон «Об ипотеке» от 16.07.1998 №102-ФЗ.</li>
			<li className={styles.orderedItem}>
				Федеральный закон «О кредитной кооперации» от 18.07.2009 №190-ФЗ.{' '}
			</li>
			<li className={styles.orderedItem}>
				Федеральный закон «О микрофинансовой деятельности и микрофинансовых организациях» от
				02.07.2010 №151-ФЗ.
			</li>
			<li className={styles.orderedItem}>
				Федеральный закон «О привлечении инвестиций с использованием инвестиционных платформ и о
				внесении изменений в отдельные законодательные акты Российской Федерации» от 02.08.2019
				№259-ФЗ.
			</li>
		</ol>
	</article>
)

export default AboutCC
